@if (isContactFormValid()) {
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    <mat-tab label="Добавить новый">
      <div
        class="form-wrapper"
        app-form-contacts-modal
        [contactFormGroup]="contactFormGroups()[0]"
        [telegramAccountIds]="telegramAccountIds()"
        [selectedTabIndex]="selectedTabIndex()"
        [isEditModeActive]="true"
        [isNew]="true"
      ></div>
    </mat-tab>
    <mat-tab
      [label]="getCurrentContactTab()"
      [disabled]="contactsData().length < 1"
    >
      <div class="form-wrapper">
        <div class="contacts-container">
          <mat-accordion [multi]="true">
            @for (contact of contactFormGroups().slice(1); track $index) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    ФИО: {{ contact.get('fio')?.value }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div
                  app-form-contacts-modal
                  [contactFormGroup]="contact"
                  [telegramAccountIds]="telegramAccountIds()"
                  [selectedTabIndex]="selectedTabIndex()"
                  [isEditModeActive]="false"
                  [isNew]="true"
                  (handleAttachClick)="handleSaveButtonClick($index)"
                ></div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  @if (!selectedTabIndex()) {
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        [disabled]="contactFormGroups().at(0)?.invalid"
        (click)="handleSaveButtonClick(-1)"
      >
        Добавить новый
      </button>
    </div>
  }
} @else {
  <app-loader/>
}
